// directives/dragScroll.js
export default {
  mounted(el) {
    let isDown = false
    let startX = 0
    let scrollLeft = 0

    const onMouseDown = (e) => {
      isDown = true
      el.classList.add('grabbing')
      startX = e.pageX - el.offsetLeft
      scrollLeft = el.scrollLeft
      el.style.cursor = 'grabbing'
    }

    const onMouseMove = (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - el.offsetLeft
      const walk = (x - startX) * 1.5 // 拖动灵敏度系数
      el.scrollLeft = scrollLeft - walk
    }

    const onMouseUp = () => {
      isDown = false
      el.classList.remove('grabbing')
      el.style.cursor = 'grab'
    }

    el.addEventListener('mousedown', onMouseDown)
    el.addEventListener('mouseleave', onMouseUp) // 鼠标离开容器时停止拖动
    el.addEventListener('mouseup', onMouseUp)
    document.addEventListener('mousemove', onMouseMove) // 全局监听，防止拖动过快丢失焦点

    // 设置初始光标样式
    el.style.cursor = 'grab'

    // 保存事件引用以便解绑
    el._dragScroll = { onMouseDown, onMouseMove, onMouseUp }
  },
  unmounted(el) {
    const { onMouseDown, onMouseMove, onMouseUp } = el._dragScroll || {}
    if (onMouseDown) el.removeEventListener('mousedown', onMouseDown)
    if (onMouseMove) document.removeEventListener('mousemove', onMouseMove)
    if (onMouseUp) {
      el.removeEventListener('mouseup', onMouseUp)
      el.removeEventListener('mouseleave', onMouseUp)
    }
  },
}
